import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';
import { ProgramaService } from '../../services/programa.service';

@Component({
  selector: 'app-programa-edit',
  templateUrl: './programa-edit.component.html',
  styleUrls: ['./programa-edit.component.scss']
})
export class ProgramaEditComponent extends BaseFormComponent<ProjetoCadastro> implements OnInit, OnDestroy {
  audit: AtualizacoesAudit;
  usuarioList: Usuario[];
  orgaoList: any[];
  ativoList: any[] = [{ id: 0, label: 'Não' }, { id: 1, label: 'Sim' }];
  idOrgaoUsuario: number;
  idPrograma: number;
  programa: ProjetoCadastro;

  constructor(
    private myService: ProgramaService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private storage: StorageService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loading();
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.idOrgaoUsuario = this.storage.getInfoUser()?.orgao_id;

    this.form = this.fb.group({
      id: [''],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      description: [''],
      agency_id: [this.idOrgaoUsuario, [Validators.required]],
      actived: [1],
      manager_cpf: [null],
      manager_adjunct_cpf: [null],
    });

    if (this.programa) {
      this.form.patchValue(this.programa);
      this.audit = {
        pg_id: this.programa.id
      };
    }
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.update(this.getDataCreate(), this.programa?.id).subscribe({
          next: (res: ProjetoCadastro) => {
            this.msgSuccess('Programa alterado com sucesso!');
            EventSharedService.get('auditRefresh').emit();
            EventSharedService.get('reloadLayout').emit(this);
            this.loaded();
          },
          error: (error) => {
            this.msgError(error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back(['projetos', 'programa']);
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.programa?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Programa excluído com sucesso!').subscribe(() => {
          this.loading();
          this.navigation.replace(['projetos', 'programa']);
        });
      },

      error: (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      }
    });
  }
}
